<template>
  <div>
    <div v-if="user.role === 'admin'">
      <nav>
        <div class="nav nav-tabs flex-row mb-4" id="nav-tab" role="tablist">
          <a
            class="nav-item nav-link active"
            id="nav-old-tab"
            data-toggle="tab"
            href="#nav-old"
            role="tab"
            aria-controls="nav-old"
            aria-selected="true"
          >
            Operator reviews
          </a>
          <a
            class="nav-item nav-link"
            id="nav-new-tab"
            data-toggle="tab"
            href="#nav-new"
            role="tab"
            aria-controls="nav-new"
            aria-selected="false"
          >
            New reviews
          </a>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-old" role="tabpanel" aria-labelledby="nav-old-tab">
          <app-operator-review></app-operator-review>
        </div>
        <div class="tab-pane fade" id="nav-new" role="tabpanel" aria-labelledby="nav-new-tab">
          <app-new-review></app-new-review>
        </div>
      </div>
    </div>

    <div v-if="user.role === 'operator'">
      <app-operator-review></app-operator-review>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OperatorReview from "./OperatorReview.vue";
import NewReview from "./NewReview.vue";

export default {
  name: "Review",

  components: {
    appOperatorReview: OperatorReview,
    appNewReview: NewReview,
  },

  computed: mapGetters(["user"]),
};
</script>
